import * as React from "react";

import Application from "./Application";

const options = Object.create(process.env.options as any);

Application.build({
  options,
  container: document.getElementById(options.appMountId),
  renderer: import("./modules/Switch"),
});
